import React from 'react'
import styles from './iconStyles.module.scss'

export default function FaChevronRight() {
  return (
    <div className={styles.FaChevronRight} />
  )
}
